import { MIN_MATCHING_SCORE } from '~/app/pages/configurator/components/dialogs/car-matching-results-dialog/models/constants';

export const getScoreLabel = (value: number) => {
	switch (value) {
		case 1:
			return `Show a score of ${value * 100}%`;

		case MIN_MATCHING_SCORE:
			return 'Show all vehicles';

		default:
			return `Show a score of ${value * 100}% and above`;
	}
};

export const getHashMarks = (minRadius: number, maxRadius: number) => {
	const hashArray = [];

	for (let i = 100; i < maxRadius; i += 100) {
		hashArray.push(i - minRadius);
	}

	return hashArray;
};
